// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4a3da836","186":"c1256bdf","272":"88bec988","372":"055ad690","738":"2925d412","841":"5bb78b17","851":"4df3e318","856":"338dd697"}[chunkId] + ".chunk.js";
};